import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.1473 7.69082L13.8585 11.9796L18.1473 16.3092C18.6782 16.7993 18.6782 17.6571 18.1473 18.1472C17.6571 18.6782 16.7994 18.6782 16.3092 18.1472L12.0205 13.8585L7.69087 18.1472C7.20073 18.6782 6.34297 18.6782 5.85283 18.1472C5.32184 17.6571 5.32184 16.7993 5.85283 16.3092L10.1416 11.9796L5.85283 7.69082C5.32184 7.20068 5.32184 6.34293 5.85283 5.85279C6.34297 5.3218 7.20073 5.3218 7.69087 5.85279L12.0205 10.1415L16.3092 5.85279C16.7994 5.3218 17.6571 5.3218 18.1473 5.85279C18.6782 6.34293 18.6782 7.20068 18.1473 7.69082Z",
		fill: "currentColor"
	})
});
export default SvgClose;
